// @flow
import React, { Component } from "react"
import Waypoint from "react-waypoint"

type Props = {
  render: State => any,
}

type State = {
  inView: boolean,
}

class WhenInView extends Component<Props, State> {
  state = {
    inView: false,
  }

  render() {
    return (
      <Waypoint
        onEnter={() => this.setState({ inView: true })}
        bottomOffset="25%"
      >
        {this.props.render(this.state)}
      </Waypoint>
    )
  }
}

export default WhenInView



// WEBPACK FOOTER //
// ./src/components/WhenInView.js